<template>
 <div>
    <div class="lds-dual-ring" v-if="loading && !error"></div>
    <div v-if="error" class="error" id="login_error"><AlertCircleOutline/> panels not found</div>
    
  <div class="banner" v-if="!loading">
    <div class="bannercontent">
        <div class="logo"></div>
        <div class="bannertitle">Create panels</div>
        <div class="bannerdesc"><div class="tag">Create panels for BLT use</div></div>
    </div>
  </div>

  <div class="content" v-if="!loading">
      <div class="bannerdesc">This page can be used to create multiple panels for BLT testing. Select the desired panel template, specify the amount of panels to create, and optionally provide a reference for tracking purposes. 
      Once created, a PDF with BLT labels will be generated for printing. You can provide an offset for the labels if you are using a label sheet that is partially used.
      </div>

    <form @submit.prevent="createPanels" class="panel-form" style="display:flex;flex-direction:column;gap:12px;max-width:420px;">
      <div class="form-row" style="display:flex;align-items:center;gap:8px;">
        <label for="template" class="label" style="min-width:120px">Panel type:</label>
        <select id="template" v-model="selectedTemplate" required style="flex:1;padding:6px;">
          <option disabled value="">-- Select template --</option>
          <option v-for="template in templates" :key="template.panelTemplateID" :value="template.panelTemplateID">
            {{ template.name }} - {{ template.requestedComponent }}
          </option>
        </select>
      </div>

      <div class="form-row" style="display:flex;align-items:center;gap:8px;">
        <label for="amount" class="label" style="min-width:120px">Amount:</label>
        <input id="amount" type="number" v-model.number="panelAmount" min="1" style="width:100px;padding:6px;" />
      </div>

      <div class="form-row" style="display:flex;align-items:center;gap:8px;">
        <label for="reference" class="label" style="min-width:120px">Reference:</label>
        <input id="reference" type="text" v-model="reference" placeholder="Reference" style="flex:1;padding:6px;" />
      </div>

      <div class="form-row" style="display:flex;align-items:center;gap:8px;">
        <label for="offset" class="label" style="min-width:120px">Label offset:</label>
        <input id="offset" type="text" v-model="labeloffset" placeholder="Label offset" style="flex:1;padding:6px;" />
      </div>

      <div class="form-actions" style="display:flex;justify-content:flex-end;">
        <button class="button save" type="submit" :disabled="!selectedTemplate || panelAmount < 1" style="padding:8px 12px;">
          Create Panels
        </button>
      </div>
    </form>
  </div>
 </div>
</template>

<script>
// @ is an alias to /src
import AlertCircleOutline from 'vue-material-design-icons/AlertCircleOutline.vue'

export default {
  name: 'PanelCreate',
  components: {
    AlertCircleOutline
  },
   data() {
    return{
      templates: [],
      loading: true,
      error: false,
      selectedTemplate: '',
      panelAmount: 1,
      reference: '',
      labeloffset: 0
    }
  },
    mounted() {
      this.axios
      .get('/panel/templates')
      .then(response => {
          this.templates = response.data;
          this.loading = false
      })
      .catch(err => {
          this.error = true;
      });
  },
  methods: {
    createPanels(){
      this.loading = true;
      this.axios
      .post('/panel/create', {
        templateID: this.selectedTemplate,
        amount: this.panelAmount,
        reference: this.reference,
        labeloffset: this.labeloffset
      })
      .then(response => {
          this.loading = false;
          const pdfData = response.data.pdf;
          // Convert base64 pdf to file for download
          const linkSource = `data:application/pdf;base64,${pdfData}`;
          const downloadLink = document.createElement("a");
          const fileName = this.selectedTemplate+"_labels"+".pdf";
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          
      })
      .catch(err => {
          console.log(err);
          this.error = true;
      });
       
    }
}
}
</script>
<style scoped>
.date{
  display: inline-block;
  font-size: 12px;
  font-weight: bold;
}
.result
{
  display: inline-block;
  margin: 2px;
  padding: 3px;
  border-radius: 2px;
  text-align: left;
}
.panel
{
  display: block;
  
  width: 100%;
  height: 1024px;
  background-repeat: no-repeat;

  /* background-color: #2e2e2e; */
  position: relative;
}
.dut
{
  width: 250px;
  height: 200px;
  margin: 10px;
  background-color: #5c7080;
  opacity: 0.98;
  border-radius: 5px;
  position: absolute;
  color: white;
  text-align: center;
  top: 0;
  left: 0;
  overflow: scroll;
  border: 2px solid #3c4a54;
}
.save{
  float: right;
}
.save disabled{
  opacity: 1;
}
.label{
  display: inline-block;
  margin-right: 5px;
  min-width: 100px;
}
.info{
  color: #353535;
  margin-top: 5px;
}

.FAIL{
  background-color: #bd7171;
  color:#ffffff
}

.PASS {
  background-color: #67995b;
  color:#ffffff
}

.WARNING {
  background-color: #c78e3a;
  color:#ffffff
}
.tag {
	display: inline-block;
	margin-right: 2px;
	line-height: 15px;
	text-align: center;
}
</style>
